<template>
	<div>
		<div
			class="d-flex justify-content-between align-items-center col-lg-4"
			v-if="checkUser"
		>
			<v-select
				auto-select-first
				:items="institutes"
				v-model="currentIns"
				@change="changeInstitute"
				item-text="name"
				item-value="id"
				:label="$t('instituteName')"
				color="green"
				item-color="green"
			>
			</v-select>
		</div>
		<h5 class="filter-text">{{ $t("filterBy:") }}</h5>
		<SearchBox
			:currentIns="currentIns"
			@resetSearch="resetSearch"
			@searchForData="searchForStudents"
		/>
		<div v-if="this.firstUpdate">
			<v-data-table
				class="mt-5 students-list"
				:headers="tableHeaders"
				:items="students"
				:sort-by="tableOptions.sortBy"
				:sort-desc="tableOptions.sortDesc"
				item-key="id"
				:footer-props="{
					'show-current-page': true,
					showFirstLastPage: true,
					firstIcon: 'mdi-arrow-collapse-left',
					lastIcon: 'mdi-arrow-collapse-right',
				}"
				:items-per-page="tableOptions.itemsPerPage"
				:server-items-length="totalStudents"
				:no-data-text="noDataText"
				:page="tableOptions.page"
				:options="tableOptions"
				@update:options="updateStudents"
				@click:row="viewStudent"
			>
				<template v-slot:item.actions="{ item }">
					<v-tooltip top>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								class="mx-1"
								dense
								v-bind="attrs"
								v-on="on"
								@click.stop="viewStudent(item)"
							>
								mdi-calendar-text
							</v-icon>
						</template>
						<span>{{ $t("studentSessions") }}</span>
					</v-tooltip>
				</template>
			</v-data-table>
		</div>
		<h2 class="search-text" v-if="!this.firstUpdate">
			{{ $t("searchForStudentToListHisClasses") }}
		</h2>
	</div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";
import SearchBox from "./StudentsList/SearchBox.vue";

export default {
	name: "ClassesView",
	components: { SearchBox },
	mixins: [GlobalMixin],
	data() {
		return {
			institutes: [],
			tutors: [],
			currentIns: null,
			students: [],
			totalStudents: null,
			userObj: JSON.parse(localStorage.getItem("vuex")),

			//flag to hide data table before search for student
			firstUpdate: false,

			tableFooterOptions: {
				"items-per-page-options": [10, 20, 30, 40, 50, 100],
				"show-current-page": true,
				showFirstLastPage: true,
				firstIcon: "mdi-arrow-collapse-left",
				lastIcon: "mdi-arrow-collapse-right",
			},
			tableOptions: {
				page: 1,
				offset: +this.$route.query.offset ? +this.$route.query.offset : 0,
				itemsPerPage: +this.$route.query.limit ? +this.$route.query.limit : 10,
				sortBy: [],
				sortDesc: [],
			},
			search: {},
			noDataText: " ",
		};
	},
	mounted() {
		// Get query params for the URL
		this.currentIns = +this.$route.query.ins
			? +this.$route.query.ins
			: this.getInstituteId;
		// Call institutes in case of super admin
		if (this.userObj.auth.user.user.user_type === "operator") {
			this.getAllInstitutes();
		}
		this.getInstituteTutors();
	},
	methods: {
		/**
		 * Get all Institutes from the API
		 */
		getAllInstitutes() {
			this.axios(`${process.env.VUE_APP_APIEndPoint}institutes/`, this.headers)
				.then(
					res =>
						(this.institutes = res.data.data.sort((a, b) =>
							a?.name.toLowerCase() > b?.name.toLowerCase() ? 1 : -1
						))
				)
				.catch(err => console.error(err));
		},
		/**
		 * Get all Tutors for an institute
		 */ getInstituteTutors() {
			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}tutor/operator/listing/`,
					{
						status: "approved",
						institute: this.currentIns,
					},
					this.headers
				)
				.then(
					tutors =>
						(this.tutors = tutors.data.data.tutors.sort((a, b) =>
							a.full_name > b.full_name ? 1 : -1
						))
				)
				.catch(err => console.error(err));
		},
		/**
		 * Change Institute
		 */
		changeInstitute() {
			if (!this.currentIns) this.currentIns = 1;
			this.tableOptions.offset = 0;
			this.tableOptions.itemsPerPage = 10;
			this.tableOptions.page = 1;
			this.tableOptions.sortBy = [];
			this.tableOptions.sortOrder = [];
			history.pushState(
				{},
				null,
				`${this.$route.path}?ins=${this.currentIns}&limit=${this.tableOptions.itemsPerPage}&offset=${this.tableOptions.offset}`
			);
			this.getInstituteTutors();
			this.getAllInstituteStudents(
				this.tableOptions.offset,
				this.tableOptions.itemsPerPage
			);
		},
		/**
		 * List of all students
		 */
		getAllInstituteStudents(
			offset = 0,
			limit = this.tableOptions.itemsPerPage,
			sortBy,
			sortOrder,
			search
		) {
			const body = {
				institute: this.currentIns,
				offset,
				limit,
				sort_field: sortBy,
				sort_order:
					typeof sortOrder === "boolean"
						? sortOrder
							? "desc"
							: "asc"
						: undefined,
				...search,
			};

			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}auth/students_list/`,
					body,
					this.headers
				)
				.then(res => {
					this.students = res.data.students;
					this.totalStudents = res.data.total_records;

					// Handle Shown text if there's no Data
					!this.students.length && !Object.keys(this.search).length
						? (this.noDataText = "No Available Data.")
						: (this.noDataText = "There is No Result.");
				})
				.catch(err => this.formatErrors(err));
		},
		/**
		 * Emits when one of the options properties is updated
		 * @param options table info
		 */
		updateStudents(options) {
			this.tableOptions.sortBy = options.sortBy;
			this.tableOptions.sortDesc = options.sortDesc;
			if (!this.currentIns) this.currentIns = this.getInstituteId;
			// Get necessary values for table (itemsPerPage, page, offset)
			this.tableOptions.offset = options.itemsPerPage * (options.page - 1);
			this.tableOptions.itemsPerPage = options.itemsPerPage;
			this.tableOptions.page = this.tableOptions.offset
				? this.tableOptions.offset / this.tableOptions.itemsPerPage + 1
				: 1;
			// Change URL without reloading the page
			history.pushState(
				{},
				null,
				`${this.$route.path}?ins=${this.currentIns}&offset=${this.tableOptions.offset}`
			);
			// Get updated students with new params
			this.getAllInstituteStudents(
				this.tableOptions.offset,
				this.tableOptions.itemsPerPage,
				this.tableOptions.sortBy[0],
				this.tableOptions.sortDesc[0],
				this.search
			);
		},
		/**
		 * navigate to student classes component
		 * @param student
		 */
		viewStudent(student) {
			this.$router.push({
				name: "studentClasses",
				params: { id: student.id },
				query: { ins: this.currentIns, offset: 0, limit: 60 },
			});
		},
		/**
		 * Handle search parameters and get new table data
		 * @param searchObj search parameters
		 */
		searchForStudents(searchObj) {
			this.firstUpdate = true;
			this.search = {};
			for (let key in searchObj) {
				switch (key) {
					case "user_id":
					case "name":
					case "email":
					case "gender":
					case "student_group_name":
						if (!searchObj[key]) break;
						this.search[key] = searchObj[key];
						break;
					case "phone_number":
						if (!searchObj[key]) break;
						this.search[key] = searchObj[key].replaceAll(" ", "");
						break;
					case "is_active":
						if (!searchObj[key] && typeof searchObj[key] !== "boolean") break;
						this.search[key] = searchObj[key];
						break;
					case "date_joined_range":
						if (!searchObj[key].length) break;
						this.search.date_joined_from = searchObj[key][0] + " 00:00:00";
						this.search.date_joined_to = searchObj[key][1] + " 00:00:00";
						break;
					case "countries":
						if (!searchObj[key].length) break;
						this.search[key] = searchObj[key];
						break;
					case "age":
						if (searchObj[key][0] === 0 && searchObj[key][1] === 100) break;
						this.search.age_gt = searchObj[key][0];
						this.search.age_lt = searchObj[key][1];
						break;
					default:
				}
			}

			this.tableOptions.offset = 0;
			this.tableOptions.itemsPerPage = 15;
			this.tableOptions.page = 1;
			this.tableOptions.sortBy = [];
			this.tableOptions.sortDesc = [];
			this.getAllInstituteStudents(
				this.tableOptions.offset,
				this.tableOptions.itemsPerPage,
				this.tableOptions.sortBy[0],
				this.tableOptions.sortDesc[0],
				this.search
			);
		},
		/**
		 * Reset search filter and reset table data
		 */
		resetSearch() {
			this.tableOptions.offset = 0;
			this.tableOptions.itemsPerPage = 15;
			this.tableOptions.page = 1;
			this.tableOptions.sortBy = [];
			this.tableOptions.sortDesc = [];
			this.search = {};
			this.getAllInstituteStudents(
				this.tableOptions.offset,
				this.tableOptions.itemsPerPage,
				this.tableOptions.sortBy[0],
				this.tableOptions.sortDesc[0],
				this.search
			);
		},
	},
	computed: {
		/**
		 * Check if user is super admin or not
		 */
		checkUser() {
			return this.userObj.auth.user.user.user_type === "operator";
		},
		/**
		 * @returns institute id depends on role of the user
		 */
		getInstituteId() {
			return this.userObj.auth.user.user.user_type === "operator"
				? 1
				: +this.userObj.auth.user.user.username.slice("").at(-1);
		},
		/**
		 * Translations for table header
		 * @returns []
		 */
		// Table Data
		tableHeaders() {
			return [
				{ text: this.$t("tables.id"), value: "id" },
				{ text: this.$t("tables.name"), value: "full_name" },
				{ text: this.$t("tables.country"), value: "country_name" },
				{ text: this.$t("tables.studentsGroups"), value: "student_group_name" },
				{ text: this.$t("tables.joiningDate"), value: "date_joined" },
				{ text: this.$t("tables.gender"), value: "gender" },
				{ text: this.$t("tables.age"), value: "age" },
				{ text: this.$t("tables.status"), value: "active_text" },
				{ text: this.$t("tables.actions"), value: "actions", sortable: false },
			];
		},
	},
};
</script>

<style lang="scss" scoped>
.filter-text {
	color: #9f9f9f;
}
.search-text {
	text-align: center;
	margin: 2rem;
	color: #9f9f9f;
}
</style>
